import React, { createRef, useState, useEffect, useRef } from "react";
import { Form, Input, Button, Spin, Alert, Row } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from "react-router-dom";
import { MailOutlined, LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { enviarCorreo } from "../../../redux/correo/moduloCorreoDucks";
import { cleanUsuario } from "../../../redux/usuario/usuarioDucks";
import { KEY_PASS } from "../../../config/RouterLink";
import { valueLowerCase } from "../../../utils";
import "../../../assets/css/correo.css";

import { Link } from "react-router-dom";

const { Item } = Form;

function Correo(props) {
  const dispatch = useDispatch();
  const [captcha, setCaptcha] = useState("");
  const [error, setError] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [cargandoInfo, setCargandoInfo] = useState(false);
  const isMounted = useRef(true);
  const recaptchaRef = createRef();

  const { enviado, messageError, indicadorError } = useSelector(
    (store) => store.usuarioLogin
  );

  useEffect(() => {
    redoCaptcha();
    return () => {
      //Desmontar el componente
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      if (enviado) {
        props.history.push("/FormExito");
      } else {
        dispatch(cleanUsuario());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enviado]);

  const onFinish = (values) => {
    if (!captcha) {
      setError(true);
      setMessageAlert(
        "El código de seguridad ha vencido, por favor recarga la página"
      );
    } else {
      setError(false);
      setCargandoInfo(true);
      if (
        values.usuario.trim().toLowerCase() ===
        values.usuarioConfirma.trim().toLowerCase()
      ) {
        let dataCorreo = {
          usuarioAspirante: values.usuario.trim().toLowerCase(),
          contrasena: "",
          usuario: values.usuario.trim().toLowerCase(),
        };
        // console.log(dataCorreo);
        dispatch(enviarCorreo(dataCorreo)).then(() => {
          localStorage.setItem("correo", values.usuario);
          setCargandoInfo(false);
          setMessageAlert("El correo ha sido enviado Exitosamente");
          props.history.push("/FormExito");
        });
      }
    }
  };

  /*----------- ReCAPTCHA -------------------*/
  const redoCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      recaptchaRef.current.execute();
      setCaptcha("");
    }
  };

  const handleCaptcha = (e) => {
    //console.log("onChange prop - Captcha value:", e);
    setError(false);
    if (e != null) {
      setCaptcha(e);
    }
  };

  return (
    <div className="">
      <Spin
        spinning={cargandoInfo}
        size="large"
        indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />}
      >
        <Row align="center">
          <div className="login-container">
            <Form name="basic" className="login-form" onFinish={onFinish}>
              <div>
                {indicadorError && (
                  <Alert
                    message={messageError}
                    type="error"
                    showIcon
                    closable
                  />
                )}
              </div>

              <Item
                name="usuario"
                rules={[
                  {
                    required: true,
                    message: "Por favor escribe tu correo electrónico",
                  },
                  {
                    type: "email",
                    message: "Formato inválido",
                  },
                  { validateStatus: "error" },
                ]}
                getValueFromEvent={valueLowerCase}
              >
                <Input
                  prefix={<MailOutlined style={{ color: "#ABB2B9" }} />}
                  placeholder="Correo electrónico registrado"
                  autoCapitalize="none"
                  type="email"
                  size="large"
                  style={{ width: "300px", marginTop: "36px" }}
                  maxLength={100}
                />
              </Item>

              <Item
                name="usuarioConfirma"
                rules={[
                  {
                    required: true,
                    message: "Por favor confirma tu correo electrónico",
                  },
                  {
                    type: "email",
                    message: "Formato inválido",
                  }, //Se valida que los correos coincidan
                  ({ getFieldValue, setFieldsValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("usuario") === value) {
                        return Promise.resolve("");
                      }
                      return Promise.reject(
                        new Error("El correo electrónico no coincide")
                      );
                    },
                  }),
                ]}
                getValueFromEvent={valueLowerCase}
              >
                <Input
                  prefix={<MailOutlined style={{ color: "#ABB2B9" }} />}
                  placeholder="Confirmar correo electrónico registrado"
                  type="email"
                  size="large"
                  style={{ width: "300px", marginTop: "36px" }}
                  maxLength={100}
                />
              </Item>
              
              <div>
                {error && (
                  <Alert
                    message={messageAlert}
                    type="error"
                    showIcon
                    closable
                  />
                )}
              </div>

              <Item>
                <ReCAPTCHA
                  sitekey={KEY_PASS}
                  ref={recaptchaRef}
                  size="invisible"
                  onChange={handleCaptcha}
                  onExpired={redoCaptcha}
                />

                <div style={{ textAlign: "center", marginTop: "54px" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="correo-form-button"
                    size="large"
                  >
                    Enviar correo
                  </Button>
                </div>

                <div>
                  <p className="pie-texto">¿Aún no tienes cuenta?</p>
                  <Link to={"/registro"} className="pie-texto-ref">
                    Regístrate
                  </Link>{" "}
                  <span className="pie-texto-refct">
                    para iniciar con tu solicitud.
                  </span>
                </div>
              </Item>
            </Form>
          </div>
        </Row>
      </Spin>
    </div>
  );
}

export default withRouter(Correo);
